//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };
import {createRequest} from "../../utils/utils"
import {setImage} from "../../api/api"
export default {
  name: "characterInsufficient",
  props: {
    modelViewId: Number,
    imageType: Number,
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data() {
    return {};
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    onFreeOfCharge() {
      if (this.imageType == 1) {

        setImage({
          image_id: this.modelViewId,
          chat_type: 1,
        }).then(d => {
          this.$emit("onFreeOfCharge", false);
        }, e => {
        
        })

      } else {
        createRequest(
          "post",
          "applet/webview/card/setting",
          {
            card_id: this.modelViewId,
            chat_type: 1,
          },
          (res) => {
            this.$emit("onFreeOfCharge", false);
            console.log("%c⧭", "color: #364cd9", res);
          },
          (err) => {
          }
        );
      }
    },
    onClones()
    {
        this.$emit("onFreeOfCharge", false);
    },
    onCharge() {
      this.$emit("onCharge", true);
    },
  },
  watch: {},
};



// WEBPACK FOOTER //
// ./src/myComponents/characterInsufficient/characterInsufficient.vue